import column from './column'
import grouped from './grouped'
import horizontalStacked from './horizontalStacked'
import hybrid from './hybrid'
import line from './line'
import pie from './pie'
import stacked from './stacked'

const Configs = {
  column,
  grouped,
  horizontalStacked,
  hybrid,
  line,
  pie,
  stacked
}

export const largeSizes = ['md', 'lg']

export const legendDefault = (labelColor, disabled = false) => ({
  useDefaultMarker: true,
  disabled: disabled,
  labels: {
    text: '{name}',
    fill: labelColor,
    fontSize: 11,
    maxWidth: 50,
    marginLeft: 0,
    // marginRight: 0,
    // marginTop: 0,
    // marginBottom: 0,
    paddingBottom: 8,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0
  },
  contentAlign: 'left',
  fixedWidthGrid: true,
  markers: {
    children: [
      {
        width: 12,
        height: 12
      }
    ]
  },
  itemContainers: {
    paddingTop: 2,
    paddingBottom: 2
  },
  // maxWidth: 50,
  maxHeight: 58,
  scrollable: true,
  // strokeWidth: 0,
  // strokeOpacity: 0,
  paddingTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: -3,
  marginLeft: 0,
  marginRight: 0,
  marginTop: 0,
  marginBottom: 0
})

export default Configs
